import { render, staticRenderFns } from "./message-timeout-warning.vue?vue&type=template&id=1f2e94e4&scoped=true"
import script from "./message-timeout-warning.vue?vue&type=script&lang=ts"
export * from "./message-timeout-warning.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1f2e94e4",
  null
  
)

export default component.exports